module.exports = __webpack_public_path__ + "img/placeholder.64934198.webp";